const getStatusListItems = locale => [
    { id: 'status.info', text: locale.devices.filters.info },
    { id: 'status.warning', text: locale.devices.filters.warning },
    { id: 'status.critical', text: locale.devices.filters.critical },
    { id: 'status.inactive', text: locale.devices.filters.inactive }
]

const getTypesListItems = locale => [
    { id: 'device_type.tm01-1', text: locale.devices.deviceTypes['tm01-1'] },
    { id: 'device_type.tom', text: locale.devices.deviceTypes.tom },
    { id: 'device_type.jerry', text: locale.devices.deviceTypes.jerry },
    {
        id: 'device_type.jerry-lora',
        text: locale.devices.deviceTypes['jerry-lora']
    },
    {
        id: 'device_type.jerry-bait-rat',
        text: locale.devices.deviceTypes['jerry-bait-rat']
    },
    {
        id: 'device_type.trapsensor',
        text: locale.devices.deviceTypes.trapsensor
    },
    { id: 'device_type.networkDevice', text: locale.locations.networkDevice }
]

export const getMainListItems = locale => [
    {
        id: 'status',
        text: locale.reports.status,
        subLists: getStatusListItems(locale),
        type: 'dropdown'
    },
    {
        id: 'type',
        text: locale.reports.type,
        subLists: getTypesListItems(locale),
        type: 'dropdown'
    }
]

export const INFESTED_ID = 'status.infested'
export const TRIGGERED_ID = 'status.triggered'
export const CONNECTIVITY_ID = 'status.connectivity'
export const getEventTypeListItems = locale => [
    {
        id: TRIGGERED_ID,
        text: locale.reports.triggered,
        urlParamName: 'isTriggered',
        description: locale.reports.triggeredDescription,
        icon: 'pencil-outline'
    },
    {
        id: INFESTED_ID,
        text: locale.reports.infested,
        urlParamName: 'isInfested',
        description: locale.reports.infestedDescription,
        icon: 'pencil-outline'
    },
    {
        id: CONNECTIVITY_ID,
        text: locale.reports.connectivity,
        description: locale.reports.connectivityDescription,
        icon: 'pencil-outline'
    }
]
